import { Injectable } from '@angular/core'
import { Actions, Effect, ofType } from '@ngrx/effects'
import { ForwardService } from '@tv3/store/forward/forward.service'
import {
  AddForwards,
  AddForwardsComplete,
  DeleteForward,
  DeleteForwardComplete,
  LoadForwards,
  LoadForwardsComplete,
} from './forward.actions'
import { catchError, concatMap, map, switchMap } from 'rxjs/operators'
import { ActionFailed } from '@tokeet-frontend/utility'
import { of } from 'rxjs'
import * as R from 'ramda'
import { ForwardRequest } from '@tv3/interfaces/requests/forward.request'

@Injectable()
export class ForwardEffects {
  @Effect()
  loadForwards$ = this.actions$.pipe(
    ofType(LoadForwards),
    switchMap(() =>
      this.forwards.all().pipe(
        map((forwards) => LoadForwardsComplete({ forwards })),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  addForward$ = this.actions$.pipe(
    ofType(AddForwards),
    map(({ form }) =>
      R.map((rentalId) => {
        return {
          forward: form.forward,
          rental_id: rentalId,
        } as ForwardRequest
      }, form.rentals)
    ),
    switchMap((requests) =>
      this.forwards.create(requests).pipe(
        map((forwards) => AddForwardsComplete({ forwards })),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  deleteForward$ = this.actions$.pipe(
    ofType(DeleteForward),
    concatMap(({ forward }) =>
      this.forwards.remove(forward).pipe(
        map(() => DeleteForwardComplete({ id: forward.id })),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  constructor(private actions$: Actions, private forwards: ForwardService) {}
}
